import { Link } from "react-router-dom";
import { BUSINESS, quotePath } from "../../content/site";
import { SiteIcon } from "./SiteIcon";

interface CtaBandProps {
  title?: string;
  sub?: string;
  /** Product slug — the quote link appends ?product={slug} (BR-WEB-002). */
  product?: string;
}

const ROOF = (
  <svg className="roof" viewBox="0 0 520 260" fill="none" stroke="#fff" strokeWidth="10" aria-hidden="true" focusable="false">
    <path d="M10 250 260 20l250 230" />
    <path d="M60 250 260 66l200 184M110 250 260 112l150 138" />
  </svg>
);

/** Red quote band that closes every public page. Keeps a link named "Get a free quote". */
export function CtaBand({
  title = "Ready to start? Get an obligation-free quote.",
  sub = "Tell us about your project — a local rep reviews every enquiry and gets back to you within two business days.",
  product,
}: CtaBandProps) {
  return (
    <section className="gw-cta" aria-label="Get a quote">
      {ROOF}
      <div className="gw-wrap">
        <div>
          <h2>{title}</h2>
          <p>{sub}</p>
        </div>
        <div className="gw-actions">
          <Link className="gw-btn gw-btn-white gw-btn-lg" to={quotePath(product)}>
            Get a free quote <SiteIcon name="arrow" size={18} />
          </Link>
          <a className="gw-btn gw-btn-ghost gw-btn-lg" href={BUSINESS.tel}>
            <SiteIcon name="phone" size={18} /> {BUSINESS.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
